import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=793031ba&scoped=true&lang=html&"
import script from "./notification.vue?vue&type=script&lang=js&"
export * from "./notification.vue?vue&type=script&lang=js&"
import style0 from "./notification.vue?vue&type=style&index=0&id=793031ba&lang=scss&scoped=true&"
import style1 from "./notification.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793031ba",
  null
  
)

export default component.exports